import { set } from 'lodash';
import { Observable } from 'rxjs';
import logger from 'services/logger';
import { Config, ConfigStorageKey } from 'types/config';

/**
 * Create an observable emitting the current application configuration object
 */
export const createConfig$ = () =>
  new Observable<Config>(subscriber => {
    logger.debug('config', 'Building application configuration');

    // Build default application configuration
    const config: Config = {
      api: {
        baseUrl: (window.adelante.api.baseUrl ?? '').trim(),
      },
      app: {
        baseUrl: (window.adelante.app.baseUrl ?? '').trim(),
      },
    };

    // List of supported local storage configuration keys
    const keys: Array<ConfigStorageKey> = ['api.baseUrl'];

    // Override config values from configuration entries available in the local storage
    for (const key of keys) {
      const value = localStorage.getItem(key);
      if (value) {
        set(config, key, value);
      }
    }

    logger.debug('config', 'Application configuration loaded');
    subscriber.next(config);
  });
